import variables from '@/styles/element-variables.scss'

const state = {
    theme: variables.theme,
    collapseMenu: false
}

const mutations = {
    CHANGE_SETTING: (state, { key, value }) => {
        if (state.hasOwnProperty(key)) {
            state[key] = value
        }
    },
    SET_COLLAPSEMENU: (state, collapseMenu) => {
        state.collapseMenu = collapseMenu
    }
}

const actions = {
    changeSetting ({ commit }, data) {
        commit('CHANGE_SETTING', data)
    },
    ChangeCollapseMenu ({ commit }, collapseMenu) {
        commit('SET_COLLAPSEMENU', collapseMenu)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
